import React from 'react';
import './PrivacyPolicyPage.css'; // Import the CSS file below
import CommonHeader from '../components/CommonHeader';
import Footer from '../components/Footer';

const PrivacyPolicyPage = () => {
  const lastUpdated = "April 25, 2026";

  return (
    <div className="policy-wrapper">
      <CommonHeader title="Privacy Policy" description="Learn how we protect your data and respect your privacy." />
      <div className="policy-container">

        <header className="policy-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: {lastUpdated}</p>
        </header>

        <div className="policy-body">
          <section className="policy-section">
            <p className="intro-text">
              Your privacy is important to us. This Privacy Policy explains how we collect, use,
              disclose, and safeguard your information when you use our application.
              Please read this policy carefully.
            </p>
          </section>

          <section className="policy-section">
            <h2>1. Information We Collect</h2>
            <div className="sub-section">
              <h3>Personal Data</h3>
              <p>Personally identifiable information, such as your name, email address, and demographic information that you voluntarily give to us when you register.</p>
            </div>
            <div className="sub-section">
              <h3>Derivative Data</h3>
              <p>Information our servers automatically collect, such as your IP address, browser type, operating system, and access times.</p>
            </div>
          </section>

          <section className="policy-section">
            <h2>2. Use of Your Information</h2>
            <p>We use information collected about you to:</p>
            <ul>
              <li>Create and manage your account.</li>
              <li>Process transactions and send related information.</li>
              <li>Monitor and analyze usage and trends to improve experience.</li>
              <li>Increase the efficiency and operation of the application.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>3. Disclosure of Your Information</h2>
            <p>
              We may share information by law or to protect rights, or with third-party service
              providers who perform services for us (such as payment processing or hosting).
            </p>
          </section>

          <section className="policy-section">
            <h2>4. Security of Your Information</h2>
            <p>
              We use administrative, technical, and physical security measures to help protect
              your personal information. However, no electronic transmission over the internet
              can be guaranteed to be 100% secure.
            </p>
          </section>

          <section className="contact-box">
            <h2>Contact Us</h2>
            <p>If you have questions or comments about this Privacy Policy, please contact us at:</p>
            <div className="contact-details">
              <p><strong>Email:</strong> support@gleamolabs.com.com</p>
              <p><strong>Address:</strong> H 2/37, Kapil Prasad, Bhubaneswar, Odisha</p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;